// @ts-nocheck



import React, { Component } from 'react';

import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
import { connect } from 'react-redux';
import { navigate } from '../../lib/routerAdapter';
import styled from 'styled-components';


import {
  addMaintenanceOperation,
  fetchMaintenanceOperation,
  updateMaintenanceOperation,
  clear } from
'../../ducks/maintenanceOperation';
import { Panel, Section } from './../../components/layout';
import Grid, { GridItem } from './../../components/layout/Grid';

import Header from '../../components/layout/Header';
import Breadcrumbs, { Crumb } from '../../components/layout/Breadcrumbs';
import { Form } from './../../components';
import { notificationLoading } from '../../components/Notifications';
import { InputNumber } from '../../components/inputs';

const Content = styled.div.withConfig({ displayName: "MaintenanceOperationForm__Content", componentId: "sc-1fgkdqh-0" })(["padding:16px;"]);


const StyledPanel = styled(Panel).withConfig({ displayName: "MaintenanceOperationForm__StyledPanel", componentId: "sc-1fgkdqh-1" })(["padding-top:0;"]);


const Footer = styled(Section).withConfig({ displayName: "MaintenanceOperationForm__Footer", componentId: "sc-1fgkdqh-2" })(["padding:16px;display:flex;justify-content:space-between;"]);















class MaintenanceOperationForm extends Component {
  async componentDidMount() {
    const { maintenanceOperationId } = this.props;
    await this.props.clear();
    try {
      if (maintenanceOperationId) {
        await this.props.fetchMaintenanceOperation(maintenanceOperationId);
      }
    } catch (err) {
      notification.error({
        message: 'Ошибка загрузки вида работы',
        description: err.message
      });
      navigate('/admin/maintenance-operations/');
    }
  }

  render() {
    const {
      maintenanceOperation,
      parentMaintenanceOperationGroupId
    } = this.props;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/admin/maintenance-operation-groups">Виды работ</Crumb>
              {maintenanceOperation ?
            <Crumb
              to={`/admin/maintenance-operations/${maintenanceOperation.id}`}>

                  Вид работы "{maintenanceOperation.name}"
                </Crumb> :

            <Crumb
              to={`/admin/maintenance-operations/${parentMaintenanceOperationGroupId}/new`}>

                  Новый вид работы
                </Crumb>
            }
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>
            {maintenanceOperation ?
            `Вид работы "${maintenanceOperation.name}"` :
            'Новый вид работы'}
          </h1>
        </StyledPanel>
        <Form
          initialValues={maintenanceOperation}
          enableReinitialize
          validate={(values) => {
            let errors = {};
            if (!values.name) {
              errors.name = 'Обязательное поле';
            }
            if (!values.hours) {
              errors.hours = 'Обязательное поле';
            }
            return errors;
          }}
          onSubmit={async (values) => {
            try {
              notificationLoading({
                message: 'Сохранение данных...',
                key: 'saving'
              });
              if (values.id) {
                await this.props.updateMaintenanceOperation(values);
              } else {
                await this.props.addMaintenanceOperation(
                  values,
                  this.props.parentMaintenanceOperationGroupId
                );
              }
              notification.success({
                message: 'Успешно сохранено',
                description: 'Изменения успешно сохранены'
              });
              navigate('/admin/maintenance-operation-groups');
            } catch (error) {
              notification.error({
                message: 'Ошибка',
                description: error.message
              });
            } finally {
              notification.destroy('saving');
            }
          }}>

          {(FormField, formikProps) => {
            const {
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              isSubmitting
            } = formikProps;
            return (
              <form onSubmit={handleSubmit}>
                <Section>
                  <Content>
                    <Grid gutter="16px">
                      <GridItem>
                        <FormField
                          label="Код работы"
                          hasFeedback
                          required
                          fast
                          name="code">

                          {({ value, name }) =>
                          <Input
                            name={name}
                            placeholder="Код работы"
                            value={value}
                            onChange={handleChange}
                            onBlur={handleBlur} />

                          }
                        </FormField>
                      </GridItem>
                      <GridItem>
                        <FormField
                          label="Наименование"
                          hasFeedback
                          required
                          fast
                          name="name">

                          {({ value, name }) =>
                          <Input
                            name={name}
                            placeholder="Наименование"
                            value={value}
                            onChange={handleChange}
                            onBlur={handleBlur} />

                          }
                        </FormField>
                      </GridItem>
                      <GridItem>
                        <FormField
                          label="Норма часы"
                          hasFeedback
                          required
                          fast
                          name="hours">

                          {({ value, name }) =>
                          <InputNumber
                            step={0.01}
                            value={value}
                            name={name}
                            onChange={(value) =>
                            setFieldValue(name, value)
                            }
                            onBlur={handleBlur} />

                          }
                        </FormField>
                      </GridItem>
                    </Grid>
                  </Content>
                </Section>
                <Footer>
                  <Button
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    type="primary"
                    htmlType="submit">

                    Сохранить
                  </Button>
                </Footer>
              </form>);

          }}
        </Form>
      </>);

  }
}

export default connect(
  (state, ownProps) => ({
    maintenanceOperation: state.maintenanceOperation,
    maintenanceOperationId: parseInt(ownProps.maintenanceOperationId, 10)
  }),
  {
    updateMaintenanceOperation,
    addMaintenanceOperation,
    fetchMaintenanceOperation,
    clear
  }
)(MaintenanceOperationForm);
